import { queryOptions } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { AdminSession } from "@/pages/admin/session";
import type { SessionWithItems } from "@/types/session";

function createUrl(session_token: string) {
  const url_params = new URLSearchParams();
  url_params.append("with_items", "1");
  return `/session/${session_token}?${url_params.toString()}`;
}

const sessionQueryOptions = (session_token: string) =>
  queryOptions<SessionWithItems>({
    queryKey: ["session", session_token],
    meta: {
      url: createUrl(session_token),
    },
  });

export const Route = createFileRoute("/session/$session_token/")({
  component: AdminSession,
  loader: ({ context: { queryClient }, params: { session_token } }) => {
    return queryClient.ensureQueryData(sessionQueryOptions(session_token));
  },
});
